import React from 'react';

import { Flex, Text } from '@opendoor/bricks/core';

type FieldValueType = number | string | null | undefined;

interface ParnLeadCardContentProps {
  fieldName: string;
  fieldValue1?: FieldValueType;
  fieldValue2?: FieldValueType;
  style?: React.CSSProperties;
  isMobile?: boolean;
}

const ParnLeadCardContent: React.FC<ParnLeadCardContentProps> = ({
  fieldName,
  fieldValue1,
  fieldValue2,
  style,
  isMobile,
}) => {
  return (
    <Flex flexDirection={'column'} alignItems="top" style={style}>
      <Text size={'100'} fontWeight={'regular'} style={{ color: 'gray' }}>
        {fieldName}{' '}
      </Text>
      <Text size={'110'} fontWeight={'medium'} style={{ paddingTop: '7px' }}>
        {fieldValue1}
      </Text>
      <Text
        size={'110'}
        fontWeight={'medium'}
        style={{ paddingTop: '3px', paddingBottom: isMobile ? '20px' : '0' }}
      >
        {fieldValue2}
      </Text>
    </Flex>
  );
};

export default ParnLeadCardContent;
